import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { MenuService } from './menuService';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AppService } from './app-service';
import { ConfirmDialogComponent } from './views/common/confirm-dialog/confirm-dialog.component';
import { UsersService } from './services/users-services/users-service';


@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: './app.component.html',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {

  @HostListener("window:onbeforeunload", ["$event"])
  clearLocalStorage(event) {
    sessionStorage.clear();
  }

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  idleTimeout: number;

  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent;

  constructor(
    private router: Router,
    public iconSet: IconSetService,
    private usersService: UsersService,
    private menuService: MenuService,
    private idle: Idle, private keepalive: Keepalive, private appService: AppService

  ) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };

    appService.getTimeOutPeriod().subscribe(timeoutPeriod => {
      idle.setIdle(timeoutPeriod);
    })

    appService.getTimeOutPeriodWarning().subscribe(timeoutPeriodWarning => {
      idle.setTimeout(timeoutPeriodWarning);
    })


    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
     // console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      //  this.childModal.hide();
      this.idleState = 'Timed out!';
      this.timedOut = true;
      if (sessionStorage.getItem("GUID") == "DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") { //Main System
        this.usersService.utilitiesGet("/LogOut?username=" + sessionStorage.getItem("Username") + "&type=System&save=true&save1=true&save2=true&save3=true&save4=true&save5=true").subscribe();
      }
      sessionStorage.clear();
      this.router.navigate(['/', 'login']);
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
    //  console.log(this.idleState);
      // this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
     // console.log(this.idleState);
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch()
        this.timedOut = false;
      } else {
        idle.stop();
      }
    })
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  hideChildModal(): void {
    // this.childModal.hide();
  }

  stay() {
    // this.childModal.hide();
    this.reset();
  }

  logout() {
    // this.childModal.hide();
    this.appService.setUserLoggedIn(false);
    sessionStorage.clear();
    this.usersService.utilitiesGet("/LogOut?username=" + sessionStorage.getItem("Username") + "&type=System&save=true&save1=true&save2=true&save3=true&save4=true&save5=true").subscribe();
    sessionStorage.clear();
    this.router.navigate(['/', 'login']);
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  confirmClick() {

  }

  getMenu() {
    this.menuService.items = [];
    if (sessionStorage.getItem("GUID") == "DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") {
      this.menuService.items.push(
        // {
        //   name: 'Dashboard',
        //   url: '/students-dashboard',
        //   icon: 'icon-speedometer',
        //   badge: {
        //     variant: 'info',
        //     text: 'Students'
        //   }
        // },
        {
          title: true,
          name: 'System Modules',
        }
      )

      if (sessionStorage.getItem("Administration") == "true") {
        this.menuService.items.push(
          {
            name: 'Registration',
            icon: 'icon-briefcase',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Students',
                url: '/students',
              },
              {
                name: 'Teachers',
                url: '/teachers',
              },
              {
                name: 'Students Upload',
                url: '/students-upload',
              },
              {
                name: 'Online Applications',
                url: '/online-applications',
              },
              {
                name: 'Cambridge Exam Series',
                url: '/cambridge-exam-series',
              },
              {
                name: 'Student ID Cards',
                url: '/student-id-cards',
              },
              {
                name: 'Student Centre',
                url: '/student-centre',
              },
              {
                name: 'External System Links',
                url: '/external-system-links',
              },
              {
                name: 'Dashboard',
                url: '/students-dashboard',
              },

            ]
          }
        )
      }

      if (sessionStorage.getItem("Students") == "true") {
        this.menuService.items.push(
          {
            name: 'Students',
            icon: 'cil-people',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Attendance',
                url: '/attendance',
              },
              {
                name: 'Extra Curricular Activities',
                url: '/extra-curricular-activities',
              },
              {
                name: 'Disciplinary Records',
                url: '/disciplinary-records',
              },
              {
                name: 'Extra Curricular Comments',
                url: '/extra-curricular-comments',
              },
              {
                name: 'Student Centre',
                url: '/student-centre',
              },
              {
                name: 'Students Overview',
                url: '/students-overview',
              },
              {
                name: 'Extra Curricular Reports',
                url: '/extra-curricular-reports',
              },
              {
                name: 'Dashboard',
                url: '/students-dashboard',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Fees") == "true") {
        this.menuService.items.push(
          {
            name: 'Fees',
            icon: 'icon-basket',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Payments',
                url: '/payments',
              },
              {
                name: 'Advance Payments',
                url: '/advance-payments',
              },
              {
                name: 'Billing',
                url: '/billing',
              },
              {
                name: 'Payment Plans',
                url: '/payment-plans',
              },
              {
                name: 'Reports',
                url: '/fees-reports',
              },
              {
                name: 'Dashboard',
                url: '/fees-dashboard',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Exams") == "true") {
        if(sessionStorage.getItem("SHP")=="Y"){
        this.menuService.items.push(
          {
            name: 'Exams',
            icon: 'icon-graduation',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Record Exams',
                url: '/exams',
              },
              {
                name: 'Record Course Work',
                url: '/course-work',
              },
              {
                name: 'House Points',
                url: '/house-points',
              },
              {
                name: 'Behaviour Points',
                url: '/behaviour-points',
              },
              {
                name: 'Virtual Classes',
                url: '/my-virtual-classes',
              },
              {
                name: 'End Of Term Reports',
                url: '/end-of-term-reports',
              },
              {
                name: 'Schemes Of Work',
                url: '/schemes-of-work',
              },
              {
                name: 'Review Schemes Of Work',
                url: '/schemes-of-work-reviews',
              },
              // {
              //   name: 'Lesson Plans',
              //   url: '/lesson-planning',
              // },
              {
                name: 'Comments Bank',
                url: '/comments-bank',
              },
              {
                name: 'Dashboard',
                url: '/exams-dashboard',
              },
            ]
          }
        )
      }
      else {
        this.menuService.items.push(
          {
            name: 'Exams',
            icon: 'icon-graduation',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Record Exams',
                url: '/exams',
              },
              {
                name: 'Record Course Work',
                url: '/course-work',
              },
              {
                name: 'Virtual Classes',
                url: '/my-virtual-classes',
              },
              {
                name: 'End Of Term Reports',
                url: '/end-of-term-reports',
              },
              {
                name: 'Schemes Of Work',
                url: '/schemes-of-work',
              },
              {
                name: 'Review Schemes Of Work',
                url: '/schemes-of-work-reviews',
              },
              // {
              //   name: 'Lesson Plans',
              //   url: '/lesson-planning',
              // },
              {
                name: 'Comments Bank',
                url: '/comments-bank',
              },
              {
                name: 'Dashboard',
                url: '/exams-dashboard',
              },
            ]
          }
        )
      }
      }

      if (sessionStorage.getItem("ResourceCentre") != "true") {
        this.menuService.items.push(
          {
            name: 'Online Resources',
            icon: 'icon-layers',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'e-Library',
                url: '/users-elibrary',
              },
              {
                name: 'Teachers Resources',
                url: '/users-teachers-resources',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Timetable") == "true") {
        this.menuService.items.push(
          {
            name: 'Timetable',
            icon: 'cil-clock',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Lesson Timetables',
                url: '/admin-lesson-timetable',
              },
              {
                name: 'Auto Generate Timetable',
                url: '/generate-timetable',
              },
              {
                name: 'Timetable Conflicts',
                url: '/timetable-conflicts',
              },
              {
                name: 'Lessons Status',
                url: '/lessons-status',
              },
              {
                name: 'Exam Timetables',
                url: '/admin-exam-timetable',
              },
              {
                name: 'Dashboard',
                url: '/timetable-dashboard',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Accomodation") == "true") {
        this.menuService.items.push(
          {
            name: 'Accomodation',
            icon: 'icon-home',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Check In',
                url: '/accomodation-check-in',
              },
              {
                name: 'Check Out',
                url: '/accomodation-check-out',
              },
              {
                name: 'Hostels',
                url: '/hostels',
              },
              {
                name: 'End Of Term Comments',
                url: '/accomodation-comments',
              },
              {
                name: 'Reports',
                url: '/accomodation-reports',
              },
              {
                name: 'Dashboard',
                url: '/accomodation-dashboard',
              }

            ]
          }
        )
      }

      if (sessionStorage.getItem("Transport") == "true") {
        this.menuService.items.push(
          {
            name: 'Transport',
            icon: 'cil-bus-alt',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Students',
                url: '/transport-students',
              },
              {
                name: 'Drivers',
                url: '/drivers',
              },
              {
                name: 'Vehicles',
                url: '/vehicles',
              },
              {
                name: 'Routes',
                url: '/routes',
              },
              {
                name: 'Pick Up Points',
                url: '/pick-up-points',
              },
              {
                name: 'Reports',
                url: '/transport-reports',
              },
              {
                name: 'Dashboard',
                url: '/transport-dashboard',
              },
            ]
          }
        )
      }

      if (sessionStorage.getItem("Communication") == "true") {
        this.menuService.items.push(
          {
            name: 'Communication',
            icon: 'icon-envelope',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Emails',
                url: '/emails',
              },
              {
                name: 'SMSs',
                url: '/smss',
              },
              {
                name: 'Notifications',
                url: '/notifications',
              },
              // {
              //   name: 'Letters',
              //   url: '/letters',
              // },
              {
                name: 'Notices',
                url: '/notices',
              },
              {
                name: 'Mobile App Documents',
                url: '/mobile-app-documents',
              },
              {
                name: 'Enquiries',
                url: '/enquiries',
              },
              {
                name: 'School Calendar',
                url: '/admin-school-calendar',
              },
              {
                name: 'Instant Messages',
                url: '/instant-messages',
              },
              {
                name: 'Dashboard',
                url: '/communication-dashboard',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Library") == "true") {
        this.menuService.items.push(
          {
            name: 'Library',
            icon: 'icon-notebook',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Book Locations',
                url: '/libraries',
              },
              {
                name: 'Book Categories',
                url: '/library-categories',
              },
              {
                name: 'Books',
                url: '/library-books',
              },
              {
                name: 'Check Out Books',
                url: '/check-out-books',
              },
              {
                name: 'Check In Books',
                url: '/check-in-books',
              },
              {
                name: 'Reserve Books',
                url: '/reserve-books',
              },
              {
                name: 'Library Penalties',
                url: '/library-penalties',
              },
              {
                name: 'Book Losses',
                url: '/library-book-losses',
              },
              {
                name: 'Reports',
                url: '/library-reports',
              },
              {
                name: 'Dashboard',
                url: '/library-dashboard',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("ResourceCentre") == "true") {
        this.menuService.items.push(
          {
            name: 'Resource Centre',
            icon: 'icon-docs',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'e-Library',
                url: '/elibrary',
              },
              {
                name: 'Teachers Resources',
                url: '/teachers-resources',
              },
              {
                name: 'Categories',
                url: '/elibrary-categories',
              },
              {
                name: 'Dashboard',
                url: '/elibrary-dashboard',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("eLearning") == "true") {
        this.menuService.items.push(
          {
            name: 'eLearning',
            icon: 'cil-touch-app',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Assignments',
                url: '/assignments',
              },
              {
                name: 'Live Lessons Streaming',
                url: '/live-lessons',
              },
              {
                name: 'Online Lessons',
                url: '/e-lessons',
              },
              {
                name: 'Lesson Exercises',
                url: '/e-lessons-exercises',
              },
              {
                name: 'Study Packs',
                url: '/study-packs',
              },
              {
                name: 'Exercises Marking',
                url: '/e-learning-exercise-marking',
              },
              {
                name: 'Online Exams',
                url: '/e-learning-exams',
              },
              {
                name: 'Online Courses',
                url: '/e-learning-courses',
              },
              {
                name: 'Scheduled Exams',
                url: '/e-learning-scheduled-exams',
              },
              {
                name: 'Exams Marking',
                url: '/e-learning-exam-marking',
              },
              {
                name: 'Reports',
                url: '/e-learning-reports',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Reports") == "true") {
        this.menuService.items.push(
          {
            name: 'Reports Centre',
            icon: 'icon-pie-chart ',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Date-Based Reports',
                url: '/reports-centre',
              },
              {
                name: 'List-Based Reports',
                url: '/reports-centre-lists',
              },
              {
                name: 'System Calendar',
                url: '/system-calendar',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Maintenance") == "true") {
        this.menuService.items.push(
          {
            name: 'Maintenance',
            icon: 'icon-wrench',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'Levels',
                url: '/levels',
              },
              {
                name: 'Classes',
                url: '/classes',
              },
              {
                name: 'Virtual Classes',
                url: '/virtual-classes',
              },

              {
                name: 'School Terms',
                url: '/school-terms',
              },
              {
                name: 'Subjects',
                url: '/subjects',
              },
              {
                name: 'Grading Scales',
                url: '/grading-scales',
              },
              {
                name: 'Departments',
                url: '/departments',
              },
              {
                name: 'Cambridge Setup',
                url: '/cambridge-setup',
              },
              {
                name: 'Schemes Of Work Archives',
                url: '/schemes-of-work-archives',
              },
              {
                name: 'Planning Reports',
                url: '/planning-reports',
              }
            ]
          }
        )
      }

      if (sessionStorage.getItem("Settings") == "true") {
        this.menuService.items.push(
          {
            name: 'Settings',
            icon: 'cil-settings',
            badge: {
              variant: 'warning',
              text: 'Module'
            },
            children: [
              {
                name: 'System Settings',
                url: '/settings',
              },
              {
                name: 'Library Settings',
                url: '/library-settings',
              },
              {
                name: 'Accomodation Settings',
                url: '/accomodation-settings',
              },
              {
                name: 'Transport Settings',
                url: '/transport-settings',
              },
              {
                name: 'System Users',
                url: '/users',
              },
              {
                name: 'System Administration',
                url: '/system-administration',
              },
              {
                name: 'Online Exams Policy',
                url: '/online-exams-policy',
              },
              {
                name: 'Types And Categories',
                url: '/types-and-categories',
              },
              {
                name: 'Report Scheduler',
                url: '/report-scheduler',
              }
            ]
          }
        )
      }

      this.menuService.items.push(
        {
          title: true,
          name: 'Extras',
        },
        {
          name: 'Home',
          url: '/home',
          icon: 'cil-institution'
        }
      )
    }
    //Student Portal
    else if (sessionStorage.getItem("GUID") == "F570BDF4-4A2F-4F8F-AEA9-518011009B1D") {
      this.menuService.items.push(
       
        {
          title: true,
          name: 'System Modules',
        }
      )
      this.menuService.items.push(
        {
          name: 'Student Portal',
          badge: {
            variant: 'info',
            text: 'Module'
          },
          children: [
            {
              name: 'My Details',
              url: '/sp-details',
              icon: 'icon-user',
            },

            {
              name: 'My Exams',
              url: '/sp-exams',
              icon: 'icon-list',
            },
            {
              name: 'Transactions',
              url: '/sp-transactions',
              icon: 'icon-wallet',
            },
            {
              name: 'Timetable',
              url: '/sp-timetable',
              icon: 'icon-calendar',
            },
            {
              name: 'Lesson Plans',
              url: '/sp-lesson-plans',
              icon: 'icon-feed',
            },            
            {
              name: 'Lesson Status',
              url: '/sp-lesson-status',
              icon: 'icon-pin',
            },
            {
              name: 'Notices',
              url: '/sp-notices',
              icon: 'icon-note',
            },
            {
              name: 'Reports',
              url: '/sp-reports',
              icon: 'icon-pie-chart',
            },
            {
              name: 'Home',
              url: '/sp-home',
              icon: 'icon-home',
            }
          ]
        }
      )
      this.menuService.items.push(
        {
          name: 'eLearning',
          badge: {
            variant: 'info',
            text: 'Module'
          },
          children: [
            {
              name: 'Assignments',
              url: '/sp-assignments',
              icon: 'icon-note',
            },

            {
              name: 'Online Exams',
              url: '/sp-online-exams',
              icon: 'icon-graduation',
            },
            // {
            //   name: 'Live Lessons',
            //   url: '/sp-live-lessons',
            //   icon: 'icon-camrecorder',
            // },
            {
              name: 'Tutorials',
              url: '/sp-online-tutorials',
              icon: 'icon-puzzle',
            },
            {
              name: 'eLibrary',
              url: '/sp-elibrary',
              icon: 'icon-magnifier',
            }
          ]
        }
      )
      this.menuService.items.push(
        {
          name: 'Dashboards',
          badge: {
            variant: 'info',
            text: 'Module'
          },
          children: [
        {
          name: 'My Dashboard',
          url: '/sp-dashboard',
          icon: 'icon-speedometer'         
        },
      ]}
      )
    }

    //Parents portal
    else if (sessionStorage.getItem("GUID") == "6291D72A-1B6E-4525-8057-92FEE3954A4A") {
      this.menuService.items.push(
       
        {
          title: true,
          name: 'System Modules',
        }
      )
      this.menuService.items.push(
        {
          name: 'Parents Portal Menu',
          badge: {
            variant: 'info',
            text: '10'
          },
          children: [
            {
              name: 'My Students',
              url: '/parents-portal-my-students',
              icon: 'cil-group',
            },
            {
              name: 'Homework',
              url: '/parents-portal-homework',
              icon: 'cil-folder-open',
            },  
            {
              name: 'Lesson Plans',
              url: '/parents-portal-lesson-plans',
              icon: 'cil-healing',
            },  
            {
              name: 'Students Exams',
              url: '/parents-portal-students-exams',
              icon: 'icon-list',
            },
            {
              name: 'Fees Transactions',
              url: '/parents-portal-fees-transactions',
              icon: 'icon-wallet',
            },   
            {
              name: 'Attendance Records',
              url: '/parents-portal-attendance-records',
              icon: 'cil-bell',
            }, 
            // {
            //   name: 'Communication Centre',
            //   url: '/parents-portal-communication-centre',
            //   icon: 'cil-chat-bubble',
            // },    
            {
              name: 'School Calendar',
              url: '/parents-portal-school-calendar',
              icon: 'cil-calendar',
            },     
            {
              name: 'Noticeboard',
              url: '/parents-portal-noticeboard',
              icon: 'icon-note',
            },
            {
              name: 'Documents',
              url: '/parents-portal-documents',
              icon: 'cil-briefcase',
            },
            {
              name: 'Home',
              url: '/parents-portal-home',
              icon: 'cil-home',
            },
          ]
        }
      )
      this.menuService.items.push(
        {
          name: 'Analytics',
          badge: {
            variant: 'info',
            text: '2'
          },
          children: [
            {
              name: 'Reports',
              url: '/parents-portal-reports',
              icon: 'icon-pie-chart',
            },
                    {
          name: 'Dashboards',
          url: '/parents-portal-students-dashboard',
          icon: 'icon-speedometer'         
        },
      ]}
      )
    }
  } 
}
